module.exports = __webpack_public_path__ + "img/play-circle-fill.69f01258.svg";